import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import { Route } from 'vue-router';
import { getFromSessionStorage } from '@/apps/order/helper';
import OrderAPI from '@/apps/order/classes/api/OrderAPI';

import {
  useOrdersCreateDataPreparedStore,
  useOrdersCreateCalculatorStore,
} from '@/apps/order/stores/ordersCreate';

import DataPreparedAddressInterface from '@/apps/order/interfaces/ordersCreate/DataPreparedAddressInterface';
import BillingTypesParamsInterface from '@/apps/order/interfaces/ordersCreate/BillingTypesParamsInterface';
import DataPreparedParamsInterface from '@/apps/order/interfaces/ordersCreate/DataPreparedParamsInterface';

let alreadyFetched = false;

const hasPreparedData = async (to: Route): Promise<void> => new Promise<void>((resolve, reject) => {
  const ctx = to.meta?.ctx;
  nextTick(async () => {
    try {
      const dataPreparedStore = useOrdersCreateDataPreparedStore();
      const dataCalculatorPreparedStore = useOrdersCreateCalculatorStore();

      const { dataAddress } = storeToRefs(dataPreparedStore);
      const { formData } = storeToRefs(dataCalculatorPreparedStore);

      if (!alreadyFetched) {
        dataAddress.value = getFromSessionStorage<DataPreparedAddressInterface | undefined>(`${ctx}.preparedDataAddress`);

        const params: DataPreparedParamsInterface = {};
        if (formData.value.salesPartnerNumber) {
          params.salesPartnerNumber = formData.value.salesPartnerNumber;
        }

        if (formData.value.brand_id) {
          params.brand_id = formData.value.brand_id;
        }

        await OrderAPI.fetchDataPreparedStepAddress(params).then((data) => {
          dataAddress.value = data;
        });

        /* eslint-disable camelcase */
        const { brand_id, sales_channel_id } = formData.value;
        if (
          !dataAddress.value?.billingTypes
            && brand_id !== undefined
            && sales_channel_id !== undefined
        ) {
          const billingParams: BillingTypesParamsInterface = {
            brand_id,
            sales_channel_id,
          };

          if (formData.value.salesPartnerNumber) {
            billingParams.salesPartnerNumber = formData.value.salesPartnerNumber;
          }

          await OrderAPI.fetchBillingTypes(billingParams).then((billingTypes) => {
            dataAddress.value = {
              ...dataAddress.value,
              billingTypes,
            } as DataPreparedAddressInterface;
          });
        }
        /* eslint-enable camelcase */
        alreadyFetched = true;
      }

      resolve();
    } catch (e) {
      reject(new Error(['fetch categories failed', e].join(' ')));
    }
  });
});

export default hasPreparedData;
